export default __webpack_public_path__ + "static/media/Menu.734b0e51.png";